import gql from 'graphql-tag';
import FieldsEmployee from 'graphql/fields/FieldsEmployee'

export default gql(`
	query employees( $guid: [String!]) {
		employees( guid: $guid ) {
			${FieldsEmployee}
			
			team {
				guid
			}
			
			department {
				guid
			}
			
			jobtitle {
				guid
			}
		}
	}
`);

